import {useEffect} from 'react';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {BackLink} from '../../../components';
import {useAmplitude} from '../../../context';
import {useLinearFlowContext} from '../../../layouts';
import {
    ContinueButton,
    Instruction,
} from '../components';

export function PackTheTube() {
    const amplitude = useAmplitude();
    const intl = useIntl();
    const {onBackLinkClickHandler} = useLinearFlowContext();

    useEffect(() => {
        amplitude.logActivationPackVisit();
    }, [amplitude]);

    return (
        <>
            <BackLink onClick={onBackLinkClickHandler} />
            <h2 data-test-id={'kit-activation-step-five-title'}>
                <FormattedMessage id={'kit.activation.stepFive.title'} />
            </h2>
            <Instruction
                image={'/images/kit-activation-five-one.svg'}
                text={intl.formatMessage({id: 'kit.activation.stepFive.instruction.one'})}
            />
            <Instruction
                image={'/images/kit-activation-five-two.svg'}
                text={intl.formatMessage({id: 'kit.activation.stepFive.instruction.two'})}
            />
            <Instruction
                className={'more-margin'}
                image={'/images/kit-activation-one-one.svg'} // Image is reused from step one
                text={intl.formatMessage({id: 'kit.activation.stepFive.instruction.three'})}
            />
            <ContinueButton />
        </>
    );
}
